import TextLoading from 'my-components/TextLoading';

export default function LoadingFallback({ lines: linesProp, value }) {
  const lines = value?.blocks?.length || linesProp || 1;
  return <TextLoading lines={lines} />;
}
